import { render, staticRenderFns } from "./Shebei.vue?vue&type=template&id=171a3cc8&scoped=true&"
import script from "./Shebei.vue?vue&type=script&lang=ts&"
export * from "./Shebei.vue?vue&type=script&lang=ts&"
import style0 from "./Shebei.vue?vue&type=style&index=0&id=171a3cc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a3cc8",
  null
  
)

export default component.exports